
/**
 * keys that are saved in local storage
 */
export enum ELocalAppDataKeys {
    userId = "user_id",
    userName = "user_name",
    token = "token",
    deviceUid = "device_uid",

    appRate = "enable_app_rate",
    openCounter = "open_counter",
    openCounterAll = "open_counter_all",
    openCounterLastTimestamp = "open_counter_last_timestamp",
    tutorialSeen = "tutorial_seen",
    firstBootDone = "first_boot_done",
    codePushUpdated = "code_push_updated",
    tutorialSeenLocal = "tutorial_seen_local",
    tutorialVideoSeen = "tutorial_video_seen",
    appSettings = "app_settings",
    versionCode = "version_code",

    pushId = "push_notifications_id",

    isTester = "is_tester",
    mapStyles = "map_styles",
    photoUrl = "photo_url_storage",
    itemImages = "item_images",

    treasureCache = "treasure_cache",

    refreshTest = "refresh_test",
    navParams = "nav_params",

    localShowFlags = "show_flags",
    trackEventFlags = "track_events",

    storyFlags = "story_flags",

    adConsent = "ad_consent",
    cameraInitialized = "camera_initialized",

    openStory = "open_story",
    checkpointProgress = "checkpoint_progress",

    locationChecked = "location_checked"
}

export interface IAppFlagsGen {
    [key: string]: IAppFlagsElement;
}

export interface IAppFlagsGenContent {
    [key: string]: any;
}

/**
 * a collection of app flags
 */
export interface IAppFlags extends IAppFlagsGen {
    appRate: IAppFlagsElement;
    openCounter: IAppFlagsElement;
    tutorialSeen: IAppFlagsElement;
    firstBootDone: IAppFlagsElement;
    openCounterAll: IAppFlagsElement;
    codePushUpdated: IAppFlagsElement;
    openCounterLastTimestamp: IAppFlagsElement;
}

/**
 * app flags element key-value pair
 */
export interface IAppFlagsElement {
    flag: string;
    value: any;
}


/** 
 * custom storage flags
 */
export interface ILocalShowFlags {
    gmapTutorial: boolean,
    droneTutorial: boolean,
    arTutorial: boolean
}


export interface IStoryFlags {
    includeBeta: boolean
}

export class AppFlags {
    static generalFlags: IAppFlags = {
        appRate: {
            flag: ELocalAppDataKeys.appRate,
            value: true
        },
        openCounter: {
            flag: ELocalAppDataKeys.openCounter,
            value: 0
        },
        tutorialSeen: {
            flag: ELocalAppDataKeys.tutorialSeen,
            value: false
        },
        firstBootDone: {
            flag: ELocalAppDataKeys.firstBootDone,
            value: false
        },
        openCounterAll: {
            flag: ELocalAppDataKeys.openCounterAll,
            value: 0
        },
        codePushUpdated: {
            flag: ELocalAppDataKeys.codePushUpdated,
            value: false
        },
        openCounterLastTimestamp: {
            flag: ELocalAppDataKeys.openCounterLastTimestamp,
            value: 0
        }
    };
}